module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navbar/navbar.component.css
// module id = ./src/app/components/navbar/navbar.component.css
// module chunks = main